/* Sticker Packs builder. Deck list comes from sticker-stack-deck.js (window.SS_DECK).
   Kept ASCII-only: Shopify serves assets without a charset. */

/* Kiss-cut sheets the shopper can choose (inches, portrait). Stickers are autofitted onto them by
   spPack below. */
window.SP_SHEET_SIZES = [{ id: '4x6', w: 4, h: 6 }, { id: '5x7', w: 5, h: 7 }, { id: '8.5x11', w: 8.5, h: 11 }, { id: '12x12', w: 12, h: 12 }];
/* SP_PACK:begin - generated from Desktop/sticker-stack/sp-pack-core.js by inject_pack.py; edit there. */
/* Kiss-cut autofit: puts a pack's stickers on as few sheets as possible. Inches; a sticker's longest
   side = size; at least 0.125 in between cut lines and 0.25 in from the sheet edge.
   Every sticker stays upright, so the whole sheet reads one way and nobody turns it to peel a
   sticker; the sheet itself may be used tall or wide (spTurns), whichever needs fewer sheets.
   spPack runs the fast rectangle packer on the stickers' boxes (spQuick) and nests their real
   outlines (spNest), keeping whichever needs fewer sheets (ties: the rectangles, then the tall sheet).
   Both always run: interlocking outlines can beat any bound worked out from the boxes. spBonus then
   finds free bonus stickers for the room left (spWith lays the same set out again on the platform).
   Uses only + - * / and sqrt, so the storefront preview and the platform's print file get
   identical results.
   shapes[i] = {a: width / height, o: outline from outlines.py}. Returns {w, h, sheets, places[i] =
   {sheet, x, y, w, h, angle}}: w x h is the sheet as used (tall or wide), (x, y) the sticker's
   centre from its top-left, w x h its size, angle always 0. Null when a sticker can't fit. */
function spPack(shapes, size, sheet) {
  var best = spQuick(shapes, size, sheet);
  spTurns(sheet).forEach(function (sh) { var n = spNest(shapes, size, sh); if (n && (!best || n.sheets < best.sheets)) best = n; });
  return best;
}
// The sheet tall, then wide.
function spTurns(sheet) { return sheet.w === sheet.h ? [{ w: sheet.w, h: sheet.h }] : [{ w: sheet.w, h: sheet.h }, { w: sheet.h, h: sheet.w }]; }
// Rectangle packing on the tall and the wide sheet, the better one.
function spQuick(shapes, size, sheet) {
  var best = null;
  spTurns(sheet).forEach(function (sh) { var r = spRects(shapes, size, sh); if (r && (!best || r.sheets < best.sheets)) best = r; });
  return best;
}

/* Rectangle packing (MaxRects, stickers upright): tries 4 sticker orders x 3 placement rules, keeps
   the fewest sheets, then spreads the stickers evenly over that many sheets and centres each sheet. */
function spRects(shapes, size, sheet) {
  var M = 0.25, G = 0.125, W = sheet.w, H = sheet.h, E = 1e-9;
  function r4(x) { return Math.round(x * 1e4) / 1e4; }
  var items = shapes.map(function (sh, i) { var a = sh && sh.a > 0 ? sh.a : 1; return { i: i, w: r4(a >= 1 ? size : size * a), h: r4(a >= 1 ? size / a : size) }; });
  var ORDERS = [
    function (p, q) { return (Math.max(q.w, q.h) - Math.max(p.w, p.h)) || (q.w * q.h - p.w * p.h) || (p.i - q.i); },
    function (p, q) { return (q.w * q.h - p.w * p.h) || (p.i - q.i); },
    function (p, q) { return (Math.min(q.w, q.h) - Math.min(p.w, p.h)) || (Math.max(q.w, q.h) - Math.max(p.w, p.h)) || (p.i - q.i); },
    function (p, q) { return (q.h - p.h) || (q.w - p.w) || (p.i - q.i); }
  ];
  var RULES = [
    function (r, w, h) { return [Math.min(r.w - w, r.h - h), Math.max(r.w - w, r.h - h)]; },
    function (r, w, h) { return [r.w * r.h - w * h, Math.min(r.w - w, r.h - h)]; },
    function (r, w, h) { return [r.y + h, r.x]; }
  ];
  function fresh() { return [{ x: M, y: M, w: W - 2 * M + G, h: H - 2 * M + G }]; }
  function better(s, r, b) {
    if (!b) return true;
    for (var q = 0; q < 2; q++) { if (s[q] < b.s[q] - E) return true; if (s[q] > b.s[q] + E) return false; }
    if (r.y < b.y - E) return true; if (r.y > b.y + E) return false;
    return r.x < b.x - E;
  }
  function best(free, it, rule) {
    var b = null, w = it.w + G, h = it.h + G;
    for (var f = 0; f < free.length; f++) {
      var r = free[f];
      if (w > r.w + E || h > r.h + E) continue;
      var s = rule(r, w, h);
      if (better(s, r, b)) b = { s: s, x: r.x, y: r.y, w: w, h: h };
    }
    return b;
  }
  function inside(a, b) { return a.x >= b.x - E && a.y >= b.y - E && a.x + a.w <= b.x + b.w + E && a.y + a.h <= b.y + b.h + E; }
  function split(free, u) {
    var out = [];
    for (var f = 0; f < free.length; f++) {
      var r = free[f];
      if (u.x >= r.x + r.w - E || u.x + u.w <= r.x + E || u.y >= r.y + r.h - E || u.y + u.h <= r.y + E) { out.push(r); continue; }
      if (u.x > r.x + E) out.push({ x: r.x, y: r.y, w: u.x - r.x, h: r.h });
      if (u.x + u.w < r.x + r.w - E) out.push({ x: u.x + u.w, y: r.y, w: r.x + r.w - u.x - u.w, h: r.h });
      if (u.y > r.y + E) out.push({ x: r.x, y: r.y, w: r.w, h: u.y - r.y });
      if (u.y + u.h < r.y + r.h - E) out.push({ x: r.x, y: u.y + u.h, w: r.w, h: r.y + r.h - u.y - u.h });
    }
    return out.filter(function (a, i) {
      for (var j = 0; j < out.length; j++) if (j !== i && inside(a, out[j]) && (j < i || !inside(out[j], a))) return false;
      return true;
    });
  }
  function place(places, sheets, k, b, it) {
    places[it.i] = { sheet: k, x: r4(b.x), y: r4(b.y), w: r4(b.w - G), h: r4(b.h - G) };
    sheets[k] = split(sheets[k], { x: b.x, y: b.y, w: b.w, h: b.h });
  }
  function firstFit(order, rule) {
    var sheets = [], places = [];
    for (var n = 0; n < order.length; n++) {
      var it = order[n], done = false;
      for (var k = 0; k < sheets.length && !done; k++) { var b = best(sheets[k], it, rule); if (b) { place(places, sheets, k, b, it); done = true; } }
      if (!done) { sheets.push(fresh()); var b2 = best(sheets[sheets.length - 1], it, rule); if (!b2) return null; place(places, sheets, sheets.length - 1, b2, it); }
    }
    return { count: sheets.length, places: places };
  }
  function balanced(order, rule, count) {
    var sheets = [], places = [], used = [];
    for (var s0 = 0; s0 < count; s0++) { sheets.push(fresh()); used.push(0); }
    for (var m = 0; m < order.length; m++) {
      var it = order[m], pick = -1, pb = null;
      for (var k = 0; k < count; k++) { var b = best(sheets[k], it, rule); if (b && (pick < 0 || used[k] < used[pick] - E)) { pick = k; pb = b; } }
      if (pick < 0) return null;
      place(places, sheets, pick, pb, it); used[pick] += it.w * it.h;
    }
    return places;
  }
  var win = null;
  for (var o = 0; o < ORDERS.length; o++) {
    var order = items.slice().sort(ORDERS[o]);
    for (var u = 0; u < RULES.length; u++) {
      var ff = firstFit(order, RULES[u]);
      if (ff && (!win || ff.count < win.count)) win = { count: ff.count, places: ff.places, order: order, rule: RULES[u] };
    }
  }
  if (!win) return null;
  var places = balanced(win.order, win.rule, win.count) || win.places;
  for (var k = 0; k < win.count; k++) {
    var x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
    places.forEach(function (p) { if (p.sheet === k) { x0 = Math.min(x0, p.x); y0 = Math.min(y0, p.y); x1 = Math.max(x1, p.x + p.w); y1 = Math.max(y1, p.y + p.h); } });
    if (x0 === Infinity) continue;
    var dx = (W - (x1 - x0)) / 2 - x0, dy = (H - (y1 - y0)) / 2 - y0;
    places.forEach(function (p) { if (p.sheet === k) { p.x += dx; p.y += dy; } });
  }
  return {
    w: W, h: H, sheets: win.count,
    places: places.map(function (p, i) { var it = items[i]; return { sheet: p.sheet, x: r4(p.x + p.w / 2), y: r4(p.y + p.h / 2), w: it.w, h: it.h, angle: 0 }; })
  };
}

/* The 0.1 in grid spNest and spFill place outlines on, inside the 0.25 in sheet margin. A cell is
   taken when its centre is inside a sticker's outline or within half the gap, plus half a cell and
   the simplification tolerance, of an edge, so stickers whose cells don't meet are a gap apart. */
function spRaster(size, sheet) {
  var g = { M: 0.25, G: 0.125, R: 0.1 }, E = 1e-9, OUTLINE_TOL = 0.012;
  g.cols = Math.floor((sheet.w - 2 * g.M) / g.R + E); g.rows = Math.floor((sheet.h - 2 * g.M) / g.R + E);
  g.PAD = g.G / 2 + g.R * 0.5 + OUTLINE_TOL * size;
  g.r4 = function (x) { return Math.round(x * 1e4) / 1e4; };
  // A sticker: its size and outline (inches, centred), from the deck's aspect and outline string.
  g.item = function (sh, i) {
    var a = sh && sh.a > 0 ? sh.a : 1, w = a >= 1 ? 1 : a, h = a >= 1 ? 1 / a : 1, str = sh && sh.o ? sh.o : '', pts = [];
    for (var k = 0; k + 4 <= str.length; k += 4) pts.push([(parseInt(str.substr(k, 2), 36) / 1000 - 0.5) * size, (parseInt(str.substr(k + 2, 2), 36) / 1000 - 0.5) * size]);
    if (pts.length < 3) pts = [[-w / 2 * size, -h / 2 * size], [w / 2 * size, -h / 2 * size], [w / 2 * size, h / 2 * size], [-w / 2 * size, h / 2 * size]];
    var far = 0;
    pts.forEach(function (p) { far = Math.max(far, Math.sqrt(p[0] * p[0] + p[1] * p[1])); });
    return { i: i, w: g.r4(w * size), h: g.r4(h * size), pts: pts, far: far, mask: null };
  };
  // Is (x, y) inside the outline, or within d of one of its edges?
  function near(pts, x, y, d) {
    var inside = false, dd = d * d;
    for (var a = 0, b = pts.length - 1; a < pts.length; b = a++) {
      var ax = pts[a][0], ay = pts[a][1], bx = pts[b][0], by = pts[b][1];
      if ((ay > y) !== (by > y) && x < (bx - ax) * (y - ay) / (by - ay) + ax) inside = !inside;
      var ex = bx - ax, ey = by - ay, len = ex * ex + ey * ey, u = len > 0 ? ((x - ax) * ex + (y - ay) * ey) / len : 0;
      u = u < 0 ? 0 : u > 1 ? 1 : u;
      var qx = ax + u * ex - x, qy = ay + u * ey - y;
      if (qx * qx + qy * qy <= dd) return true;
    }
    return inside;
  }
  // Cells (column dx, row dy from the mask's corner) a sticker covers, and its centre within the mask.
  function mask(it) {
    if (it.mask) return it.mask;
    var R = g.R, ext = it.far + g.PAD, n = Math.ceil(2 * ext / R), on = [];
    var x0 = n, y0 = n, x1 = -1, y1 = -1;
    for (var j = 0; j < n; j++) for (var i = 0; i < n; i++) {
      var px = -ext + (i + 0.5) * R, py = -ext + (j + 0.5) * R;
      if (near(it.pts, px, py, g.PAD)) { on.push([i, j]); if (i < x0) x0 = i; if (j < y0) y0 = j; if (i > x1) x1 = i; if (j > y1) y1 = j; }
    }
    var m = { w: x1 - x0 + 1, h: y1 - y0 + 1, cx: ext - x0 * R, cy: ext - y0 * R, cells: [] };
    on.forEach(function (p) { m.cells.push((p[1] - y0) * g.cols + (p[0] - x0)); });
    return (it.mask = m);
  }
  function fits(grid, m, at) {
    for (var q = 0; q < m.cells.length; q++) if (grid[at + m.cells[q]]) return false;
    return true;
  }
  // Gravity: the highest row with room, then the leftmost spot in it.
  g.spot = function (grid, it) {
    var m = mask(it);
    if (m.w > g.cols || m.h > g.rows) return null;
    for (var y = 0; y + m.h <= g.rows; y++) for (var x = 0; x + m.w <= g.cols; x++) if (fits(grid, m, y * g.cols + x)) return { x: x, y: y, m: m };
    return null;
  };
  g.take = function (grid, got) { var at = got.y * g.cols + got.x; for (var q = 0; q < got.m.cells.length; q++) grid[at + got.m.cells[q]] = 1; };
  // Takes the cells a sticker already placed with its centre at (x, y) (inches from the sheet's top-left) covers.
  g.mark = function (grid, it, x, y) {
    var R = g.R, ext = it.far + g.PAD;
    var i0 = Math.max(0, Math.floor((x - ext - g.M) / R)), i1 = Math.min(g.cols - 1, Math.ceil((x + ext - g.M) / R));
    var j0 = Math.max(0, Math.floor((y - ext - g.M) / R)), j1 = Math.min(g.rows - 1, Math.ceil((y + ext - g.M) / R));
    for (var j = j0; j <= j1; j++) for (var i = i0; i <= i1; i++) if (near(it.pts, g.M + (i + 0.5) * R - x, g.M + (j + 0.5) * R - y, g.PAD)) grid[j * g.cols + i] = 1;
  };
  return g;
}

/* Shape nesting on the spRaster grid, upright. Each sticker goes in the spot whose bottom edge is
   highest, then leftmost, on the first sheet with room; three sticker orders are tried and the
   fewest sheets win; each sheet is then centred. */
function spNest(shapes, size, sheet) {
  var g = spRaster(size, sheet), M = g.M, R = g.R, cols = g.cols, rows = g.rows, r4 = g.r4, W = sheet.w, H = sheet.h;
  var items = shapes.map(g.item);
  function nest(order) {
    var grids = [], places = [];
    for (var n = 0; n < order.length; n++) {
      var it = order[n], got = null, k = 0;
      for (; k < grids.length && !got; k++) got = g.spot(grids[k], it);
      if (got) k--;
      else { grids.push(new Uint8Array(cols * rows)); k = grids.length - 1; got = g.spot(grids[k], it); if (!got) return null; }
      g.take(grids[k], got);
      places[it.i] = { sheet: k, gx: got.x, gy: got.y, m: got.m };
    }
    return { count: grids.length, places: places };
  }
  var orders = [
    function (p, q) { return (q.w * q.h - p.w * p.h) || (p.i - q.i); },
    function (p, q) { return (Math.min(q.w, q.h) - Math.min(p.w, p.h)) || (q.w * q.h - p.w * p.h) || (p.i - q.i); },
    function (p, q) { return (Math.max(q.w, q.h) - Math.max(p.w, p.h)) || (Math.min(q.w, q.h) - Math.min(p.w, p.h)) || (p.i - q.i); }
  ];
  var win = null;
  for (var o = 0; o < orders.length; o++) {
    var got = nest(items.slice().sort(orders[o]));
    if (got && (!win || got.count < win.count)) win = got;
  }
  if (!win) return null;
  // Centre each sheet's stickers: shift by the empty space around the cells they cover.
  var shift = [];
  for (var k2 = 0; k2 < win.count; k2++) {
    var a0 = cols, b0 = rows, a1 = 0, b1 = 0;
    win.places.forEach(function (p) { if (p.sheet === k2) { a0 = Math.min(a0, p.gx); b0 = Math.min(b0, p.gy); a1 = Math.max(a1, p.gx + p.m.w); b1 = Math.max(b1, p.gy + p.m.h); } });
    shift.push([((cols - (a1 - a0)) / 2 - a0) * R, ((rows - (b1 - b0)) / 2 - b0) * R]);
  }
  return {
    w: W, h: H, sheets: win.count,
    places: win.places.map(function (p, i) {
      var it = items[i], sh = shift[p.sheet];
      return { sheet: p.sheet, x: r4(M + p.gx * R + p.m.cx + sh[0]), y: r4(M + p.gy * R + p.m.cy + sh[1]), w: it.w, h: it.h, angle: 0 };
    })
  };
}

/* Free bonus stickers: puts extra stickers in the room left on a finished plan (spPack's) without
   moving anything or adding a sheet. Each extra, in order, goes in the highest then leftmost spot
   with room on the first sheet that has one, or is skipped; at most `max` go in. Returns the plan
   with the extras' places after the picks' and `took` = the indexes of the extras that went in.
   Given just the extras it took, in order, it places them all again in the same spots. */
function spFill(plan, shapes, extras, size, max) {
  var g = spRaster(size, plan), grids = [], places = plan.places.slice(), took = [];
  for (var k = 0; k < plan.sheets; k++) grids.push(new Uint8Array(g.cols * g.rows));
  plan.places.forEach(function (p, i) { g.mark(grids[p.sheet], g.item(shapes[i], i), p.x, p.y); });
  for (var e = 0; e < extras.length && took.length < max; e++) {
    var it = g.item(extras[e], e), got = null, s = 0;
    for (; s < grids.length; s++) if ((got = g.spot(grids[s], it))) break;
    if (!got) continue;
    g.take(grids[s], got);
    places.push({ sheet: s, x: g.r4(g.M + got.x * g.R + got.m.cx), y: g.r4(g.M + got.y * g.R + got.m.cy), w: it.w, h: it.h, angle: 0 });
    took.push(e);
  }
  return { plan: { w: plan.w, h: plan.h, sheets: plan.sheets, places: places }, took: took };
}

/* Free bonus stickers for a finished pack: up to max of the extras (in order), in the room its
   sheets have left, never an extra sheet. Repacks the pack with the first k extras (the largest k
   that still fits) and fills the room around the pack as it is (spFill), keeping whichever takes
   more. Returns {plan, took: indexes into extras}. */
function spBonus(shapes, extras, size, sheet, max) {
  var base = spPack(shapes, size, sheet);
  if (!base) return null;
  var fill = spFill(base, shapes, extras, size, max), lo = 0, hi = Math.min(max, extras.length);
  while (lo < hi) {
    var mid = (lo + hi + 1) >> 1, p = spPack(shapes.concat(extras.slice(0, mid)), size, sheet);
    if (p && p.sheets <= base.sheets) lo = mid; else hi = mid - 1;
  }
  var took = fill.took;
  if (lo > took.length) { took = []; for (var e = 0; e < lo; e++) took.push(e); }
  return { plan: spWith(base, shapes, took.map(function (e) { return extras[e]; }), size, sheet, max).plan, took: took };
}
// A pack's layout with a set of bonus extras: all repacked together when that needs no extra
// sheet, else the extras filled around the pack as it is (those that fit). Returns {plan, took}.
function spWith(base, shapes, extras, size, sheet, max) {
  if (!extras.length) return { plan: base, took: [] };
  var p = spPack(shapes.concat(extras), size, sheet);
  if (p && p.sheets <= base.sheets) return { plan: p, took: extras.map(function (x, e) { return e; }) };
  return spFill(base, shapes, extras, size, max);
}
/* SP_PACK:end */
window.SP_PACK = spPack;
window.SP_RECTS = spRects;
window.SP_QUICK = spQuick;
window.SP_FILL = spFill;
window.SP_BONUS = spBonus;
window.SP_NEST = spNest;

(function () {
  var root = document.querySelector('[data-sp]');
  if (!root || root.__sp || !window.SS_DECK) return;
  root.__sp = 1;

  var DECK = window.SS_DECK, BASE = root.getAttribute('data-base') || '';
  var SIZE = parseInt(root.getAttribute('data-size'), 10) || 25;
  var STORE = 'sp-pack-v4';
  var X = String.fromCharCode(215), DOT = ' ' + String.fromCharCode(183) + ' ';
  var COLS = [['all', 'All'], ['funny', 'Funny'], ['quotes', 'Quotes'], ['trippy', 'Trippy'], ['meme', 'Memes'], ['cute', 'Cute'], ['trades', 'Blue Collar'], ['oklahoma', 'Oklahoma'], ['adult', '18+']];
  var byId = {};
  DECK.forEach(function (d) { byId[d.id] = d; });

  var $ = function (s) { return root.querySelector(s); };
  var stage = $('[data-sp-stage]'), board = $('[data-sp-board]'), sheet = $('[data-sp-sheet]'), rx = $('[data-sp-rx]'), ry = $('[data-sp-ry]');
  var grid = $('[data-sp-grid]'), rail = $('[data-sp-rail]'), msg = $('[data-sp-msg]'), search = $('[data-sp-search]');
  var tabs = $('[data-sp-tabs]'), startOverBtn = $('[data-sp-startover]');
  var addBtn = $('[data-sp-add]'), undoBtn = $('[data-sp-undo]'), clearBtn = $('[data-sp-clear]'), shareBtn = $('[data-sp-share]');
  var fmtSel = $('[data-sp-format]'), sizeSel = $('[data-sp-size]'), sheetSel = $('[data-sp-sheet-size]'), sheetSpec = $('[data-sp-sheet-spec]');
  var SHEETS = window.SP_SHEET_SIZES;

  // ---------- variants: Format x Size ----------
  var variants = [];
  try { variants = JSON.parse(document.querySelector('[data-sp-variants]').textContent) || []; } catch (e) {}
  function uniq(a) { return a.filter(function (v, i) { return v != null && a.indexOf(v) === i; }); }
  function inches(s) { var n = parseFloat(String(s || '').replace(/[^0-9.]/g, '')); return n > 0 ? n : 0; }
  var formats = uniq(variants.map(function (v) { return v.f; }));
  var sizes = uniq(variants.map(function (v) { return v.s; })).filter(function (s) { return inches(s); }).sort(function (a, b) { return inches(a) - inches(b); });
  if (!sizes.length) sizes = ['3 in'];
  function kindOf(f) { return /die/i.test(f || '') ? 'diecut' : 'sheet'; }
  function money(c) { return '$' + (c / 100).toFixed(2); }
  function current() {
    return variants.filter(function (v) { return v.f === fmtSel.value && (!v.s || v.s === sizeSel.value || !inches(v.s)); })[0] || null;
  }
  formats.forEach(function (f) { fmtSel.add(new Option(f, f)); });
  sizes.forEach(function (s) { sizeSel.add(new Option(s, s)); });
  if (sizes.indexOf('3 in') >= 0) sizeSel.value = '3 in';
  SHEETS.forEach(function (sh) { sheetSel.add(new Option(sh.w + ' ' + String.fromCharCode(215) + ' ' + sh.h + ' in', sh.id)); });
  sheetSel.value = '8.5x11';
  function sheetOf(id) { return SHEETS.filter(function (sh) { return sh.id === id; })[0] || SHEETS[2]; }
  // The picked stickers autofitted onto the chosen sheet: the same answer as spPack (what the print
  // file uses). The quick rectangle layout shows straight away; the final plan (shape nesting, and
  // bonus stickers once the pack is full) follows a moment later.
  // sheetPlan(true) waits for the final answer (adding to the cart).
  var planCache = { key: '', plan: null, bonus: [], final: false }, nestTimer = 0;
  function shapesOf(ids) { return ids.map(function (id) { var d = byId[id]; return { a: d.a || 1, o: d.o || '' }; }); }
  // Free bonus stickers: a full kiss-cut pack's sheets usually have room left, so spBonus adds up to
  // BONUS_MAX extra stickers from bonusPool (candidates from the pack's own collections), never an
  // extra sheet. The platform lays the same ones out the same way (spWith).
  var BONUS_MAX = 10, BONUS_POOL = 30, bonusPool = [];
  function newBonus(n, avoid) {
    var cs = {}, adult = false;
    picks.forEach(function (id) { cs[byId[id].c] = 1; if (byId[id].c === 'adult') adult = true; });
    var ok = function (d) { return (adult || d.c !== 'adult') && picks.indexOf(d.id) < 0 && avoid.indexOf(d.id) < 0; };
    var near = shuffle(DECK.filter(function (d) { return cs[d.c] && ok(d); })), rest = shuffle(DECK.filter(function (d) { return !cs[d.c] && ok(d); }));
    return near.concat(rest).slice(0, n).map(function (d) { return d.id; });
  }
  function slender(id) { var a = byId[id].a || 1; return Math.min(a, 1 / a); }
  function bonusIds() { return planCache.bonus; }
  // A full pack's bonus candidates; a new pool tries slender stickers first (they fit gaps best), swaps add to the end.
  function ensurePool() {
    if (picks.length < SIZE) return;
    if (!bonusPool.length) bonusPool = newBonus(BONUS_POOL, []).sort(function (p, q) { return slender(p) - slender(q); });
    else if (bonusPool.length < BONUS_POOL) bonusPool = bonusPool.concat(newBonus(BONUS_POOL - bonusPool.length, bonusPool));
  }
  function finalPlan(size, sh) {
    var shapes = shapesOf(picks);
    if (picks.length < SIZE) return { plan: spPack(shapes, size, sh), bonus: [] };
    var r = spBonus(shapes, shapesOf(bonusPool), size, sh, BONUS_MAX);
    return r ? { plan: r.plan, bonus: r.took.map(function (e) { return bonusPool[e]; }) } : { plan: null, bonus: [] };
  }
  function sheetPlan(final) {
    ensurePool();
    var size = inches(sizeSel.value) || 3, sh = sheetOf(sheetSel.value), key = size + '|' + sh.id + '|' + picks.join('.') + '|' + bonusPool.join('.');
    if (planCache.key === key && (planCache.final || !final)) return planCache.plan;
    if (!picks.length) planCache = { key: key, plan: { w: sh.w, h: sh.h, sheets: 1, places: [] }, bonus: [], final: true };
    else if (final) { var fp = finalPlan(size, sh); planCache = { key: key, plan: fp.plan, bonus: fp.bonus, final: true }; }
    else {
      var shapes = shapesOf(picks), rects = spQuick(shapes, size, sh);
      planCache = { key: key, plan: rects, bonus: [], final: !rects };
      if (!planCache.final) {
        clearTimeout(nestTimer);
        nestTimer = setTimeout(function () {
          if (planCache.key !== key || planCache.final) return;
          var was = planCache.plan, fp = finalPlan(size, sh);
          planCache = { key: key, plan: fp.plan, bonus: fp.bonus, final: true };
          if (fp.bonus.length || fp.plan !== was) { renderSheet(); renderStatus(); }
        }, 80);
      }
    }
    return planCache.plan;
  }
  // Stickers on one side of a sheet, at most, for squares of the chosen size (0.25 in margin, 0.125 in gap).
  function perSheet(w, h, size) { var n = function (len) { return Math.floor((len - 0.375) / (size + 0.125) + 1e-9); }; return n(w) * n(h); }
  // A sheet is offered when it holds at least two square stickers of the chosen size (so every sticker
  // fits, and a pack isn't 15 cards with one sticker each).
  function sheetFits(sh, size) { return perSheet(sh.w, sh.h, size) >= 2; }
  // Sheet sizes too small for the sticker size are greyed out; if the chosen one stops fitting, move to the smallest that does.
  function syncSheets() {
    var size = inches(sizeSel.value) || 3;
    Array.prototype.forEach.call(sheetSel.options, function (o) { o.disabled = !sheetFits(sheetOf(o.value), size); });
    if (sheetSel.options[sheetSel.selectedIndex].disabled) { var ok = Array.prototype.filter.call(sheetSel.options, function (o) { return !o.disabled; })[0]; if (ok) sheetSel.value = ok.value; }
    sheetSpec.hidden = kindOf(fmtSel.value) !== 'sheet';
  }

  var picks = [], history = [], chip = 'all', query = '';
  var focus = -1; // the one kiss-cut sheet on show (Sheet buttons), or -1 for all of them

  function src(d) { return BASE + d.f; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function shuffle(a) { for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)), t = a[i]; a[i] = a[j]; a[j] = t; } return a; }
  var TILT = [-6, 4, -2, 7, -4, 3, -7, 5, -1, 6, -5, 2, -3, 6, -6, 1, 5, -4, 7, -2, 3, -7, 4, -1, 6];

  // ---------- collections rail + library ----------
  function inChip(d, c) { c = c || chip; return c === 'all' ? d.c !== 'adult' : d.c === c; }
  function renderRail() {
    var html = '';
    COLS.forEach(function (c) {
      var items = DECK.filter(function (d) { return inChip(d, c[0]); });
      if (!items.length) return;
      var icon = items[Math.min(items.length - 1, c[0] === 'all' ? 3 : 0)];
      html += '<button type="button" class="sp__railbtn' + (c[0] === 'adult' ? ' sp__railbtn--adult' : '') + '" data-c="' + c[0] + '" aria-pressed="' + (chip === c[0]) + '">' +
        '<img src="' + src(icon) + '" alt="" loading="lazy">' + esc(c[1]) + '</button>';
    });
    rail.innerHTML = html;
  }
  function libraryItems() {
    var q = query.trim().toLowerCase();
    // Searching looks through every collection (18+ only when that collection is open).
    return DECK.filter(function (d) {
      if (q) return d.n.toLowerCase().indexOf(q) >= 0 && (d.c !== 'adult' || chip === 'adult');
      return inChip(d);
    });
  }
  function count(id) { var n = 0; picks.forEach(function (p) { if (p === id) n++; }); return n; }
  function renderLibrary() {
    var items = libraryItems(), html = '';
    items.forEach(function (d) {
      var n = count(d.id);
      html += '<li><button type="button" class="sp__tile' + (n ? ' is-picked' : '') + '" data-id="' + d.id + '" aria-label="Add ' + esc(d.n) + (n ? ', ' + n + ' in pack' : '') + '">' +
        '<img src="' + src(d) + '" alt="" loading="lazy" decoding="async">' +
        (n ? '<span class="sp__badge">' + n + '</span><span class="sp__minus" data-minus="' + d.id + '" aria-hidden="true">&minus;</span>' : '') +
        '</button><span class="sp__tilename">' + esc(d.n) + '</span></li>';
    });
    grid.innerHTML = html || '<li class="sp__none">No stickers match.</li>';
    var label = (COLS.filter(function (c) { return c[0] === chip; })[0] || COLS[0])[1];
    $('[data-sp-coltitle]').textContent = query.trim() ? 'Search results' : (chip === 'all' ? 'Sticker library' : label);
    $('[data-sp-libcount]').textContent = items.length + ' stickers';
  }

  // ---------- the pack ----------
  // A sticker at its centre (x, y), unrotated size w x h and clockwise angle, in the units of W x H.
  // Slots past the picks are free bonus stickers: tapping one swaps it for another.
  function slotHtml(cell, i, W, H, newIndex, ids) {
    var d = byId[(ids || picks)[i]], b = i - picks.length;
    var pos = 'left:' + ((cell.x - cell.w / 2) / W * 100) + '%;top:' + ((cell.y - cell.h / 2) / H * 100) + '%;width:' + (cell.w / W * 100) + '%;height:' + (cell.h / H * 100) + '%;' + (cell.angle ? 'transform:rotate(' + cell.angle + 'deg);' : '');
    if (d && b >= 0) return '<button type="button" class="sp__slot is-full is-bonus" data-bonus="' + b + '" style="' + pos + '" aria-label="Free bonus sticker ' + esc(d.n) + ', tap for a different one">' +
      '<img src="' + src(d) + '" alt="' + esc(d.n) + '"><span class="sp__free">Free</span></button>';
    if (d) return '<button type="button" class="sp__slot is-full' + (i === newIndex ? ' is-new' : '') + '" data-slot="' + i + '" style="' + pos + '--r:' + TILT[i % TILT.length] + 'deg" aria-label="Remove ' + esc(d.n) + ' from pack">' +
      '<img src="' + src(d) + '" alt="' + esc(d.n) + '"></button>';
    return '<div class="sp__slot is-empty" style="' + pos + '" aria-hidden="true"><span>' + (i + 1) + '</span></div>';
  }
  // Kiss-cut: each sheet the shopper gets, with the picked stickers autofitted (sheets appear as
  // stickers are added). Die-cut: the stickers loose on the mat; how they're laid out for printing
  // doesn't matter to the shopper.
  function renderSheet(newIndex) {
    var kind = kindOf(fmtSel.value), html = '';
    syncSheets();
    startOverBtn.hidden = !picks.length;
    sheet.setAttribute('data-kind', kind);
    board.classList.add('is-multi');
    if (kind === 'sheet') {
      var plan = sheetPlan(), cards = [], ids = picks.concat(bonusIds());
      for (var k = 0; k < plan.sheets; k++) cards.push('');
      plan.places.forEach(function (cell, i) { cards[cell.sheet] += slotHtml(cell, i, plan.w, plan.h, newIndex, ids); });
      if (!picks.length) cards[0] = '<p class="sp__cardhint">Pick stickers and they\'ll be fitted onto your sheets here.</p>';
      if (focus >= plan.sheets) focus = -1;
      sheet.innerHTML = cards.map(function (inner, k) { return '<div class="sp__card" data-card="' + k + '"' + (focus >= 0 && k !== focus ? ' hidden' : '') + '>' + inner + '<span class="sp__cardlabel">Sheet ' + (k + 1) + '</span></div>'; }).join('');
      renderTabs(plan.sheets);
      fit();
      return;
    }
    renderTabs(0);
    for (var i = 0; i < SIZE; i++) {
      var d = byId[picks[i]], a = d && d.a > 0 ? d.a : 1, r = Math.floor(i / 5), c = i % 5;
      html += slotHtml({ x: c + 0.5, y: r + 0.5, w: 0.84 * (a >= 1 ? 1 : a), h: 0.84 * (a >= 1 ? 1 / a : 1), angle: 0 }, i, 5, 5, newIndex);
    }
    sheet.innerHTML = html;
    fit();
  }
  // Sheet buttons under the sheets (2 or more): All, Sheet 1, Sheet 2...; one shows just that sheet.
  function renderTabs(n) {
    tabs.hidden = n < 2;
    if (n < 2) { focus = -1; tabs.innerHTML = ''; return; }
    var html = '<button type="button" class="sp__sheettab" data-sp-tab="-1" aria-pressed="' + (focus < 0) + '">All</button>';
    for (var k = 0; k < n; k++) html += '<button type="button" class="sp__sheettab" data-sp-tab="' + k + '" aria-pressed="' + (focus === k) + '">Sheet ' + (k + 1) + '</button>';
    tabs.innerHTML = html;
  }
  function showSheet(k) {
    focus = k;
    Array.prototype.forEach.call(sheet.querySelectorAll('.sp__card'), function (card, i) { card.hidden = k >= 0 && i !== k; });
    Array.prototype.forEach.call(tabs.querySelectorAll('[data-sp-tab]'), function (b) { b.setAttribute('aria-pressed', String(+b.getAttribute('data-sp-tab') === k)); });
    fit();
  }
  // Lays the sheet cards out in the grid that shows them biggest (just the one on show, if any).
  function fitCards() {
    var plan = sheetPlan(), n = focus >= 0 ? 1 : plan.sheets, PAD = 18, GAP = 14, LABEL = 18, best = null, TABS = tabs.hidden ? 0 : 46, TOP = startOverBtn.hidden ? 0 : 34;
    var W = stage.clientWidth - PAD * 2, H = stage.clientHeight - PAD * 2 - TABS - TOP;
    if (W <= 0 || H <= 0) return;
    for (var c = 1; c <= n; c++) {
      var r = Math.ceil(n / c), ppi = Math.min((W - (c - 1) * GAP) / (c * plan.w), (H - r * LABEL - (r - 1) * GAP) / (r * plan.h));
      if (!best || ppi > best.ppi) best = { c: c, r: r, ppi: ppi };
    }
    var cw = plan.w * best.ppi, ch = plan.h * best.ppi, tw = best.c * cw + (best.c - 1) * GAP, th = best.r * (ch + LABEL) + (best.r - 1) * GAP;
    board.style.width = tw + 'px';
    board.style.height = th + 'px';
    board.style.left = Math.round((stage.clientWidth - tw) / 2) + 'px';
    board.style.top = Math.round(TOP + (stage.clientHeight - TOP - TABS - th) / 2) + 'px';
    Array.prototype.forEach.call(sheet.querySelectorAll('.sp__card'), function (card, k) {
      var at = focus >= 0 ? 0 : k;
      card.style.left = (at % best.c) * (cw + GAP) + 'px';
      card.style.top = Math.floor(at / best.c) * (ch + LABEL + GAP) + 'px';
      card.style.width = cw + 'px';
      card.style.height = ch + 'px';
    });
  }
  function fit() {
    if (kindOf(fmtSel.value) === 'sheet') { fitCards(); return; }
    // Die-cut: a square of 5 x 5 loose stickers, as big as the workspace allows.
    var PAD = 24, TOP = startOverBtn.hidden ? 0 : 34, side = Math.min(stage.clientWidth, stage.clientHeight - TOP) - PAD * 2;
    if (side <= 0) return;
    board.style.width = board.style.height = side + 'px';
    board.style.left = Math.round((stage.clientWidth - side) / 2) + 'px';
    board.style.top = Math.round(TOP + (stage.clientHeight - TOP - side) / 2) + 'px';
  }

  function renderStatus() {
    var n = picks.length, left = SIZE - n, v = current(), kind = kindOf(fmtSel.value), size = inches(sizeSel.value);
    $('[data-sp-n]').textContent = n;
    $('[data-sp-format-text]').textContent = fmtSel.value || 'Format';
    $('[data-sp-format-icon]').setAttribute('data-kind', kind);
    $('[data-sp-size-text]').textContent = sizeSel.value;
    $('[data-sp-price]').textContent = v ? money(v.price) : '';
    $('[data-sp-each]').textContent = v ? money(Math.round(v.price / SIZE)) + ' each' : '';
    var plan = kind === 'sheet' ? sheetPlan() : null, bonus = plan ? bonusIds().length : 0;
    $('[data-sp-sheet-text]').textContent = sheetOf(sheetSel.value).w + ' ' + X + ' ' + sheetOf(sheetSel.value).h + ' in';
    $('[data-sp-dims]').textContent = (!plan ? SIZE + ' die-cut stickers, each cut out on its own'
      : !n ? 'Stickers are autofitted onto ' + plan.w + ' ' + X + ' ' + plan.h + ' in sheets as you pick them'
      : plan.sheets + ' kiss-cut sheet' + (plan.sheets > 1 ? 's' : '') + ', ' + plan.w + ' ' + X + ' ' + plan.h + ' in' + DOT + 'stickers autofitted') + DOT + 'each sticker up to ' + size + ' in on its longest side' +
      (bonus ? DOT + '+' + bonus + ' free bonus sticker' + (bonus > 1 ? 's' : '') + ' fill the room left on your sheets' : '');
    $('[data-sp-toolnote]').textContent = n + ' / ' + SIZE + ' stickers';
    addBtn.disabled = n !== SIZE || !v || !v.a;
    $('[data-sp-addlabel]').textContent = !v ? 'Unavailable' : n === SIZE ? 'Add to Cart' : 'Pick ' + left + ' more';
    $('[data-sp-live]').textContent = n === 0 ? 'Your pack, live. Pick stickers from the library.'
      : n === SIZE ? (bonus ? 'Pack complete, plus ' + bonus + ' free. Tap a sticker to swap it out.' : 'Pack complete. Tap a sticker in the pack to swap it out.') : n + ' in, ' + left + ' to go.';
    undoBtn.disabled = !history.length;
    clearBtn.disabled = shareBtn.disabled = !n;
    startOverBtn.hidden = !n;
    try { localStorage.setItem(STORE, JSON.stringify({ p: picks, b: bonusPool, f: fmtSel.value, s: sizeSel.value, h: sheetSel.value })); } catch (e) {}
  }
  function render(newIndex) { renderSheet(newIndex); renderLibrary(); renderStatus(); }

  // ---------- actions ----------
  function say(t) { msg.textContent = t; clearTimeout(say.t); if (t) say.t = setTimeout(function () { msg.textContent = ''; }, 4000); }
  function add(id) {
    if (picks.length >= SIZE) { say('Your pack is full. Tap a sticker in the pack to swap it out.'); return; }
    history.push(picks.slice()); picks.push(id); render(picks.length - 1);
  }
  function removeAt(i) { history.push(picks.slice()); picks.splice(i, 1); render(); }
  function removeOne(id) { var i = picks.lastIndexOf(id); if (i >= 0) removeAt(i); }
  function fill() {
    if (picks.length >= SIZE) return;
    history.push(picks.slice());
    var pool = DECK.filter(function (d) { return inChip(d); });
    var fresh = shuffle(pool.filter(function (d) { return picks.indexOf(d.id) < 0; })), i = 0;
    while (picks.length < SIZE && pool.length) picks.push((i < fresh.length ? fresh[i++] : pool[Math.floor(Math.random() * pool.length)]).id);
    render();
  }
  // A different free bonus sticker in place of bonus j (the next candidate that fits takes its spot).
  function swapBonus(j) {
    var at = bonusPool.indexOf(bonusIds()[j]);
    if (at < 0) return;
    bonusPool.splice(at, 1);
    renderSheet(); renderStatus();
  }
  function undo() { if (history.length) { picks = history.pop(); render(); } }
  function clearAll() { if (picks.length) { history.push(picks.slice()); picks = []; render(); } }
  // Start Over (like the Sticker Studio's): an empty pack, fresh bonus picks, all sheets on show. Undo brings the pack back.
  function startOver() {
    if (!picks.length) return;
    history.push(picks.slice()); picks = []; bonusPool = []; focus = -1;
    render();
    say('Started over. Undo brings your pack back.');
  }
  function summary() {
    var counts = {}, order = [];
    picks.forEach(function (id) { if (!counts[id]) order.push(id); counts[id] = (counts[id] || 0) + 1; });
    return order.map(function (id) { return byId[id].n + (counts[id] > 1 ? ' ' + X + counts[id] : ''); }).join(DOT);
  }
  function addToCart() {
    var v = current();
    if (picks.length !== SIZE || !v) return;
    addBtn.disabled = true;
    say('Adding your pack...');
    var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var props = { Stickers: summary(), _stack: picks.join('.'), _size_in: String(inches(sizeSel.value)), _pack_layout: 'v4' };
    if (kindOf(fmtSel.value) === 'sheet') {
      var plan = sheetPlan(true);
      props.Sheets = plan.sheets + ' ' + X + ' ' + plan.w + ' ' + X + ' ' + plan.h + ' in kiss-cut sheet' + (plan.sheets > 1 ? 's' : '');
      props._sheet_size = sheetSel.value;
      var extra = bonusIds();
      if (extra.length) { props.Bonus = extra.length + ' free: ' + extra.map(function (id) { return byId[id].n; }).join(DOT); props._bonus = extra.join('.'); }
      renderSheet(); renderStatus();
    }
    fetch(rootUrl + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: v.id, quantity: 1, properties: props }] })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'Could not add to cart'); });
      try { localStorage.removeItem(STORE); } catch (e) {}
      location.href = rootUrl + 'cart';
    }).catch(function (e) {
      addBtn.disabled = false;
      say(e.message || 'Could not add to cart. Please try again.');
    });
  }
  function share() {
    var url = location.origin + location.pathname + '?pack=' + picks.join('.') + '&size=' + encodeURIComponent(sizeSel.value) + '&format=' + encodeURIComponent(fmtSel.value) + '&sheet=' + encodeURIComponent(sheetSel.value);
    if (navigator.share) { navigator.share({ title: 'My StickerMint sticker pack', text: 'Here\'s the sticker pack I built:', url: url }).catch(function () {}); return; }
    (navigator.clipboard ? navigator.clipboard.writeText(url) : Promise.reject()).then(function () {
      say('Link copied. Anyone who opens it gets this exact pack.');
    }, function () { say(url); });
  }
  function setChip(c) {
    if (c === 'adult' && chip !== 'adult' && !confirm('Show the 18+ stickers? They have adult language and jokes.')) return;
    chip = c;
    Array.prototype.forEach.call(rail.querySelectorAll('.sp__railbtn'), function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-c') === c ? 'true' : 'false'); });
    grid.scrollTop = 0;
    renderLibrary();
  }

  // ---------- wiring ----------
  grid.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-minus]');
    if (minus) { removeOne(minus.getAttribute('data-minus')); return; }
    var t = e.target.closest('.sp__tile');
    if (t) add(t.getAttribute('data-id'));
  });
  sheet.addEventListener('click', function (e) {
    var s = e.target.closest('.sp__slot.is-full');
    if (s && s.hasAttribute('data-bonus')) swapBonus(+s.getAttribute('data-bonus'));
    else if (s) removeAt(+s.getAttribute('data-slot'));
  });
  rail.addEventListener('click', function (e) { var b = e.target.closest('.sp__railbtn'); if (b) setChip(b.getAttribute('data-c')); });
  fmtSel.addEventListener('change', function () { renderSheet(); renderStatus(); });
  sizeSel.addEventListener('change', function () { renderSheet(); renderStatus(); });
  sheetSel.addEventListener('change', function () { renderSheet(); renderStatus(); });
  search.addEventListener('input', function () { query = search.value; renderLibrary(); });
  $('[data-sp-fill]').addEventListener('click', fill);
  undoBtn.addEventListener('click', undo);
  clearBtn.addEventListener('click', clearAll);
  startOverBtn.addEventListener('click', startOver);
  tabs.addEventListener('click', function (e) { var b = e.target.closest('[data-sp-tab]'); if (b) showSheet(+b.getAttribute('data-sp-tab')); });
  shareBtn.addEventListener('click', share);
  addBtn.addEventListener('click', addToCart);
  if (window.ResizeObserver) new ResizeObserver(fit).observe(stage); else window.addEventListener('resize', fit);

  // A shared ?pack= link wins over a saved pack.
  var qs = new URLSearchParams(location.search), saved = null;
  var shared = (qs.get('pack') || '').split('.').filter(function (id) { return byId[id]; }).slice(0, SIZE);
  try { saved = JSON.parse(localStorage.getItem(STORE)); } catch (e) {}
  function pickOpt(sel, val) { if (val && Array.prototype.some.call(sel.options, function (o) { return o.value === val; })) sel.value = val; }
  if (shared.length) { picks = shared; pickOpt(sizeSel, qs.get('size')); pickOpt(fmtSel, qs.get('format')); pickOpt(sheetSel, qs.get('sheet')); }
  else if (saved && Array.isArray(saved.p)) { picks = saved.p.filter(function (id) { return byId[id]; }).slice(0, SIZE); bonusPool = (Array.isArray(saved.b) ? saved.b : []).filter(function (id) { return byId[id]; }).slice(0, BONUS_POOL); pickOpt(fmtSel, saved.f); pickOpt(sizeSel, saved.s); pickOpt(sheetSel, saved.h); }
  renderRail();
  render();
})();
